<template>
  <div class="player">
    <youtube :video-id="videoContentId" ref="youtube" />
  </div>
</template>
<script>
export default {
  name: "YouTubeManager",
  props: {
    videoContentId: {
      type: String,
      required: true
    },
    playVideo: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    player: function() {
      return this.$refs.youtube.player
    }
  },
  watch: {
    playVideo: function(newValue) {
      if (newValue === true) {
        this.player.playVideo()
      }
    }
  }
}
</script>
